import { FC } from 'react';
// Store
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectFocusModeEnabled } from 'app/store/AppUI/AppUI.selectors';
// Mui
import { Toolbar, Box, Divider } from '@mui/material';
// Components
import CaseInfo from 'app/components/CaseInfo';
// 
import CaseDetailsDropdown from './CaseDetailsDropdown';
import CaseDetailsActions from './CaseDetailsActions';
import CaseDetailsNavs from './CaseDetailsNavs';

const CaseDetailsToolbar:FC = () => {
  const focusModeEnabled = useAppSelector(selectFocusModeEnabled);

  if ( focusModeEnabled ) return null;
  return (
    <Toolbar>
      <Box sx={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        width: 384,
        minHeight: { xs: 56, sm: 63 },
        borderRight: '1px solid rgba(0,0,0,0.08)',
        pr: 1
      }}>
        <CaseInfo />
        <CaseDetailsDropdown />
      </Box>
      <Box sx={{ flexGrow: 1, pl: 4, overflow: 'hidden' }}>
        <CaseDetailsNavs />
      </Box>
      <Divider sx={{ height: 40, mx: 4 }} orientation="vertical" />
      <CaseDetailsActions />
    </Toolbar>
  )
}

export default CaseDetailsToolbar;
